import { useCallback, useEffect, useRef, useState } from "react";
import { AdoptionSummary, getAdoptionSummary } from "../api/getAdoptionSummary";

export function useDataConnectorAdoption() {
  const [summary, setSummary] = useState<AdoptionSummary | null>(null);
  const [loading, setLoading] = useState(false);
  const abortControllerRef = useRef<AbortController | null>(null);

  const cancelPendingRequest = useCallback(() => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
  }, []);

  const createSignal = useCallback(() => {
    cancelPendingRequest();
    const controller = new AbortController();
    abortControllerRef.current = controller;
    return controller.signal;
  }, [cancelPendingRequest]);

  const loadSummary = useCallback(() => {
    const signal = createSignal();
    setLoading(true);
    getAdoptionSummary(signal)
      .then((data) => {
        setSummary(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [createSignal]);

  useEffect(() => {
    loadSummary();
  }, [loadSummary]);

  useEffect(() => {
    return () => cancelPendingRequest();
  }, [cancelPendingRequest]);

  return {
    summary,
    loading,
  };
}
